import { apiFetch } from "./client";

export type RestartMode = "graceful" | "force";

export interface RestartResponse {
  accepted: boolean;
  mode: RestartMode;
  draining: boolean;
  grace_seconds: number;
  message: string;
}

export interface ServerStatus {
  draining: boolean;
  restart_requested: boolean;
  active_requests: number;
  grace_seconds: number;
}

/** Report the process drain/restart state. */
export function getServerStatus(): Promise<ServerStatus> {
  return apiFetch("/server/status");
}

/**
 * Schedule a restart of the backend (and, in development, the frontend).
 * `graceful` drains connections and forces after the grace period; `force`
 * restarts immediately.
 */
export function restartServices(mode: RestartMode): Promise<RestartResponse> {
  return apiFetch("/server/restart", {
    method: "POST",
    body: JSON.stringify({ mode }),
  });
}
